import { render, staticRenderFns } from "./excel-import.vue?vue&type=template&id=08d81ebe&scoped=true&"
import script from "./excel-import.vue?vue&type=script&lang=ts&"
export * from "./excel-import.vue?vue&type=script&lang=ts&"
import style0 from "./excel-import.vue?vue&type=style&index=0&id=08d81ebe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d81ebe",
  null
  
)

export default component.exports